import { Button, Dialog, DialogContent, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import api from '../../../api/api'
import { AGENT_CONFIG } from '../config'
import RequireField from '../../../component/RequireField'
import { Box } from '@mui/system'

export default function DialogSigner({ open, setOpen, AgentNumber, actFor, setdownloadFormAgent, signer,setSigner, year,setYear }) {
    const [signerError, setSignerError] = useState(false)
    const [yearError, setYearError] = useState(false)

    async function downloadFormAgent() {
        setdownloadFormAgent(true);
        let _params = '';
        let _actFor = '';
        let _signer = '';
        let _year = '';

        if (actFor) {
            _actFor = 'actFor=' + actFor + '&';
        }
        if (signer) {
            _signer = 'signer=' + signer;
        }
        if (year) {
            _year = '&year=' + year;
        }
        _params = '?' + _actFor + _signer + _year

        const newNumber = encodeURIComponent(AgentNumber);

        const res = await api.get(AGENT_CONFIG.requests.getAgents.url + `/${newNumber}/pdf` + _params, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data;
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        // setSigner('')
        // setYear('')
        setdownloadFormAgent(false)
    }
    const handleAdd = async () => {
        downloadFormAgent()
        setOpen(false)
    }
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='sm'
        >
            <DialogContent>
                <div class="container">
                    <div class="row w-100">
                        <div class="col-sm-12 d-flex justify-content-between">
                            <label style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#3364af',
                                marginBottom: '10px'
                            }}>
                            </label>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12" style={{ marginBottom: '10px' }} >
                            <label class="labelInput">ประจำปี</label>
                            <Box className={`backgroundField ${yearError ? 'error' : ''}`} >
                                <TextField value={year || ''} onChange={e => setYear(e.target.value)} variant="standard" fullWidth
                                    onBlur={e => {
                                        if (!e.target.value) {
                                            setYearError(true)
                                        } else {
                                            setYearError(false)
                                        }
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                    disabled={false}
                                    onKeyPress={(event) => {
                                        if ('number') {
                                            if (!/[0-9-/]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }
                                    }}
                                />
                            </Box>
                            {yearError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกปี</span>}
                        </div>
                        <div class="col-12" style={{ marginBottom: '10px' }} >
                            <label class="labelInput">ผู้ลงนาม</label>
                            <RequireField value={signer || ''} onChange={setSigner} type={'text'} error={signerError} setError={setSignerError} textError={'กรุณากรอกผู้ลงนาม'} />
                        </div>

                        <div class="col-12 mt-4 mb-3 text-end">
                            <Button onClick={() => {
                                setOpen(false)
                                // setSigner('')
                                // setYear('')
                                setSignerError(false)
                                setYearError(false)
                            }} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                            <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>

                        </div >


                    </div >


                </div >
            </DialogContent >
        </Dialog >
    )
}
